var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, Utils, PropertyConverters, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemDividerElement = class PacemDividerElement extends Components.PacemElement {
    constructor() {
        super('separator');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first && name === 'orientation') {
            this._syncOrientation(val);
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._syncOrientation();
    }
    _syncOrientation(orientation = this.orientation) {
        if (orientation !== 'vertical') {
            // exclude invalid runtime values
            orientation = 'horizontal';
        }
        super.aria.attributes.set('orientation', orientation);
        switch (orientation) {
            case 'vertical':
                Utils.addClass(this, 'divider-vertical');
                break;
            default:
                Utils.removeClass(this, 'divider-vertical');
                break;
        }
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String, emit: false })
], PacemDividerElement.prototype, "orientation", void 0);
PacemDividerElement = __decorate([
    CustomElement({
        tagName: P + '-divider', shadow: true,
        template: `<div part="divider"><div part="prepend"></div><slot part="content"></slot><div part="append"></div></div>`
    })
], PacemDividerElement);
export { PacemDividerElement };
